/**
 * Floating pill: mega menu at ≥990px (CSS hover + focus-within). Primary links navigate on click.
 * Search opens via click/JS or :focus-visible on desktop. On mobile, search opens via click/focus.
 */
(function () {
  const MQ = window.matchMedia('(min-width: 990px)');
  const SHELL_SEARCH_OPEN = 'header-floating-pill__shell--search-open';
  const SUPPRESS_HOVER_OPEN = 'header-floating-pill__suppress-hover-open';

  function shells() {
    return document.querySelectorAll('[data-floating-pill-shell]');
  }

  function clearHoverSuppress(shell) {
    shell.querySelectorAll('.' + SUPPRESS_HOVER_OPEN).forEach((el) => {
      el.classList.remove(SUPPRESS_HOVER_OPEN);
    });
  }

  /** After closing, block hover re-open until pointer leaves hovered regions (click-to-close while still hovering). */
  function suppressHoveredDropdownTriggers(shell) {
    shell.querySelectorAll('.header-floating-pill__nav-item--has-dropdown').forEach((li) => {
      const dd = li.getAttribute('data-fp-dd');
      const panel = dd ? shell.querySelector('.header-floating-pill__dropdown[data-fp-dd="' + dd + '"]') : null;
      [li, panel].forEach((el) => {
        if (!el || !el.matches(':hover')) return;
        el.classList.add(SUPPRESS_HOVER_OPEN);
        el.addEventListener(
          'mouseleave',
          () => {
            el.classList.remove(SUPPRESS_HOVER_OPEN);
          },
          { once: true }
        );
      });
    });
  }

  function closeMega(shell) {
    shell.querySelectorAll('.header-floating-pill__nav-item--has-dropdown > a[aria-haspopup="true"]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function closeSearch(shell) {
    shell.classList.remove(SHELL_SEARCH_OPEN);
    const btn = shell.querySelector('.header-floating-pill__search-trigger');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAll(shell) {
    closeMega(shell);
    closeSearch(shell);
    suppressHoveredDropdownTriggers(shell);
  }

  function onSearchClick(event) {
    const btn = event.currentTarget;
    const shell = btn.closest('[data-floating-pill-shell]');
    if (!shell) return;

    const willOpen = !shell.classList.contains(SHELL_SEARCH_OPEN);
    if (MQ.matches) closeMega(shell);
    if (willOpen) {
      clearHoverSuppress(shell);
      shell.classList.add(SHELL_SEARCH_OPEN);
      btn.setAttribute('aria-expanded', 'true');
    } else {
      shell.classList.remove(SHELL_SEARCH_OPEN);
      btn.setAttribute('aria-expanded', 'false');
      suppressHoveredDropdownTriggers(shell);
    }
  }

  function onDocumentClick(event) {
    const t = event.target;
    if (MQ.matches) {
      if (t.closest('.header-floating-pill__dropdown')) return;
      if (t.closest('.header-floating-pill__nav-item--has-dropdown a.header__menu-item')) return;
    }
    if (t.closest('.header-floating-pill__search-dropdown')) return;
    if (t.closest('[data-fp-search-trigger]')) return;
    shells().forEach(closeAll);
  }

  function onEscape(event) {
    if (event.key !== 'Escape') return;
    shells().forEach(closeAll);
  }

  function onMqChange() {
    if (!MQ.matches) {
      shells().forEach((shell) => {
        closeMega(shell);
        closeSearch(shell);
        clearHoverSuppress(shell);
      });
    }
  }

  function bindShell(shell) {
    shell.querySelectorAll('.header-floating-pill__nav-item--has-dropdown > a[aria-haspopup="true"]').forEach((a) => {
      a.setAttribute('aria-expanded', 'false');
    });

    const searchBtn = shell.querySelector('.header-floating-pill__search-trigger');
    if (searchBtn) {
      searchBtn.setAttribute('aria-expanded', 'false');
      searchBtn.addEventListener('click', onSearchClick);
    }
  }

  function setHeaderHeight() {
    const header = document.querySelector('.header-floating-pill-root');
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }

  function init() {
    setHeaderHeight();
    shells().forEach(bindShell);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);
    MQ.addEventListener('change', onMqChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
